import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NotificacionService } from 'src/app/services/notificaciones.service';
import { SocketService } from '../../services/socket.service';
import { UnitsService } from '../../services/units.service';
import { UserService } from '../../services/user.service';

@Injectable({
  providedIn: 'root',
})
export class MainLayoutService {
  constructor(
    private router: Router,
    private dialog: MatDialog,
    public userService: UserService,
    private _notification: NotificacionService,
    private readonly socketService: SocketService,
    private _snackBar: MatSnackBar,
    private unitsService: UnitsService
  ) {}

  initializeComponent(component) {
    let body = document.getElementsByTagName('BODY')[0];
    body.classList.add('mini-sidebar');

    let FRD = this.userService.currentUser.role.units.find(
      (element) => element.code == 'ALT'
    );
    if (FRD && this.userService.currentUser.role.units.length == 1) {
      component.isFRD = true;
    }
  }

  get name() {
    return this.userService.currentUser?.fullname;
  }
  get roeleName() {
    return this.userService.currentUser?.role.name;
  }
  get photo() {
    return this.userService.currentUser?.photo
      ? this.userService.currentUser?.photo
      : 'assets/images/user.png';
  }

  setupSocketConnection(component) {
    this.socketService.socket.on('new_notification', () => {
      this.getNotifications(component);
    });
  }

  getNotifications(component) {
    this._notification.countNotificationsUnread().subscribe((count) => {
      component.countNotifications = count;
    });
  }

  doLogout() {
    this.userService.doLogout();
  }

  getUnits(component) {
    this.unitsService.getAll().subscribe({
      next: (res) => {
        component.units = res;
      },
    });
  }

  get permissions() {
    return this.userService.currentUser.role;
  }
  get seeSkuld() {
    if (
      this.permissions.skuld &&
      this.userService.currentUser.role.units.length > 1
    ) {
      return true;
    } else {
      return false;
    }
  }
  get anaUnit() {
    let ana = this.userService.currentUser.role.units.find(
      (element) => element.code == 'AN'
    );
    if (ana) {
      return ana._id;
    } else {
      return false;
    }
  }
  get seeAna() {
    let ANA = this.userService.currentUser.role.units.find(
      (element) => element.code == 'AN'
    );

    if (ANA != undefined) {
      return true;
    } else {
      return false;
    }
  }

  get userUnits() {
    let role = this.userService.currentUser?.role;
    let roleunits = role.units.filter((unit) => unit.code != 'AN');
    let units = roleunits.map((unit) => {
      const nunit = {
        link: `/cases/${unit._id}`,
        name: unit.routeName || unit.name,
        exact: true,
        click: null,
        if: true,
      };
      if (unit.code == 'ALT') {
        nunit.link = `/alerts/${unit._id}`;
        nunit.name = 'Alertas';
      }
      return nunit;
    });
    units.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
    return units;
  }

  get sklud() {
    let units;
    let FRD = this.userService.currentUser.role.units.find(
      (element) => element.code == 'ALT'
    );

    if (FRD) {
      units = [
        {
          link: `/alerts/${FRD._id}`,
          name: 'Alertas',
          exact: true,
          click: null,
          if: true,
        },
      ];

      return ([] as any[]).concat(...units);
    }
  }
  get seeUsers() {
    const { createUsers, editUsers, deleteUsers } = this.permissions;
    return createUsers || editUsers || deleteUsers;
  }

  get seeRoles() {
    const { editRoles, createRoles, deleteRoles } = this.permissions;
    return editRoles || createRoles || deleteRoles;
  }

  get immersionPermission() {
    const { immersion } = this.permissions;
    return immersion;
  }

  get forskerPermission() {
    const { immersion } = this.permissions;
    return immersion;
  }

  get seeLogSistemControl() {
    return this.permissions.seeLogSistemControl;
  }
  get seeLogCases() {
    return this.permissions.seeLogCases;
  }

  get seeMainReports() {
    return this.permissions.seeMainReports;
  }
  get seeStatusConection() {
    return this.permissions.seeStatusConection;
  }

  get seeUnits() {
    const {
      createCaseType,
      editCaseType,
      deleteCaseType,
      editTask,
      createTask,
      deleteTask,
    } = this.permissions;

    return (
      createCaseType ||
      editCaseType ||
      deleteCaseType ||
      editTask ||
      createTask ||
      deleteTask
    );
  }

  clickNav(component, option: any) {
    if (option.view !== null || option.view !== undefined)
      option.view = !option.view;

    if (option.link) {
      this.router.navigate([option.link]);
      component.view = false;
    } else if (option.click) {
      component.view = false;
      component[option.click]();
    }
  }
}
